<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ANTI RAGGING SAY NO TO RAGGING</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Anti Ragging</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9 mt-0">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/content/ragging.jpeg"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ANTI RAGGING</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">NATIONAL RAGGING PREVENTION PROGRAMME</h2>
                <p><b>National Anti-Ragging Helpline</b><br/>
                    24x7 Toll Free<br/>
                </p>
                <div class="section-heading text-start mb-0">
                    <span class="sub-title"><a class="text-secondary"
                                               href="tel:1800-180-5522">1800-180-5522</a></span><br/>
                </div>
                <div class="section-heading text-start mb-0">
                <span class="sub-title"><a class="text-secondary" href="mailto:helpline@antiragging.in">helpline@antiragging.in</a> | <a
                    class="text-secondary"
                    href="www.antiragging.in"
                    target="_blank">www.antiragging.in</a></span>
                </div>
                <p>
                    <b>UGC Monitoring Agency</b><br/>
                    Centre for Youth (C4Y) <br/>
                    antiragging@c4yindia.org | www.c4yindia.org<br/>
                    <b>Contact Details of the Nodal Officers of Anti-Ragging Committee and Squad</b><br/>
                    Anti-Ragging Committee (ARC) | Anti-Ragging Squad (ARS) <br/>
                    <b>RAGGING IS A CRIMINAL OFFENCE AND THE CULPRITS WILL ATTRACT PUNITIVE ACTION AS MENTIONED IN THE
                        UGC REGULATIONS</b><br/>
                    <a href="ANTI-RAGGING/Download" target="_blank">ANTI-RAGGING/Download</a><br/>
                </p>

                <p><b>What is Ragging?</b> <br/>
                    Any Act Resulting In: <br/>
                </p>
                <ul>
                    <li>Mental/Physical/Sexual Abuse</li>
                    <li>Verbal Abuse</li>
                    <li>Indecent Behaviour</li>
                    <li>Criminal Intimidation/Wrongful Restraint</li>
                    <li>Undermining Human Dignity</li>
                    <li>Financial Exploitation/Extortion</li>
                    <li>Use of Force</li>

                </ul>

            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<section class="aboutus-style-02 pt-0">
    <div class="container">
        <div class="accordion" id="accordionExample">

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        AR PDF
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <section class="aboutus-style-02 mt-0 mb-0">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12 ">
                                        <div class="section-heading text-start mb-0">
                                            <span class="sub-title">ANTI-RAGGING COMMITTEE</span>
                                        </div>

                                        <table class="table table-responsive ">
                                            <tbody>
                                            <tr>
                                                <td>AR Committee</td>
                                                <td>
                                                    <div class="section-heading text-start mb-0">
                                                        <span class="sub-title ">
                                                <a class="text-secondary" target="_blank"
                                                   href="https://drive.google.com/file/d/1GT3P_Kx5m53ASVo00iXEcyo0jY9HJ5K-/preview">
                                                    ANTI-RAGGING CONTACT DETAILS</a>
                                            </span>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>AR Contact</td>
                                                <td>
                                                    <div class="section-heading text-start mb-0">
                                                        <span class="sub-title ">
                                                <a class="text-secondary" target="_blank"
                                                   href="https://docs.google.com/document/d/1K9B1V3F4ypdNT9C4FDsj71aSl60KRDgZ/edit?rtpof=true&sd=true&pli=1">
                                                    NATIONAL RAGGING PREVENTION PROGRAMME</a>
                                            </span>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>AR Committee</td>
                                                <td>
                                                    <div class="section-heading text-start mb-0">
                                                         <span class="sub-title ">
                                                <a class="text-secondary" target="_blank"
                                                   href="https://www.antiragging.in/assets/pdf/annexure/Annexure-I.pdf">
                                                    ANTI-RAGGING/Download</a>
                                            </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        ANTI-RAGGING COMMITTEE
                    </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="collapseFour"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">

                        <section class="contact-form pb-0">

                            <div class="container">
                                <div class="section-heading text-start mb-0">
                                    <span class="sub-title">Anti-Ragging Contact Details</span>
                                </div>
                                <div class="row mt-n2-9 mb-md-6 mb-lg-7">

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr.Gurvinder Singh</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:7986513723">7986513723</a></li>
                                                    <li><a href="#!">Chairperson</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr.Neeraj Bhandari</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:7973276326">7973276326</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr. Sunita</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:8360345882">8360345882</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Amit Sharma</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:9317613048">9317613048</a></li>
                                                    <li><a href="#!">Member Secretary</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms.Mehr Un Nisa</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:9682527090">9682527090</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr. Neha Salaria</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:8219467920">8219467920</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr.Saurabh Sharma</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:9816752737">9816752737</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Aman Sharma</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:7807385117">7807385117</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9"></div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Harjit Singh</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:7589000551">7589000551</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Narinder Pal</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="tel:8091456384">8091456384</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
